/**
 * Mobile filter drawer enhancements (parfart):
 *   1. Live search inside a filter submenu (filters the value rows as you type).
 *   2. Manual apply: checking a filter no longer auto-submits and closes the
 *      drawer. Selections are applied only when the user taps "Apply".
 *
 * The theme's <facet-filters-form> listens for `input` on the form and
 * re-renders on every change (facets.js). We stop those events (capture phase)
 * for everything inside the mobile form, then trigger the render ourselves on
 * Apply using the theme's own createSearchParams()/renderPage().
 */
(function () {
  var MOBILE_FORM_ID = 'FacetFiltersFormMobile';

  function normalize(text) {
    return (text || '')
      .toString()
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '');
  }

  function filterSubmenu(input) {
    var submenu = input.closest('.mobile-facets__submenu');
    if (!submenu) return;

    var query = normalize(input.value);
    var items = submenu.querySelectorAll('[data-facet-item]');
    var visible = 0;

    items.forEach(function (item) {
      var name = normalize(item.getAttribute('data-facet-name'));
      var match = query === '' || name.indexOf(query) !== -1;
      item.classList.toggle('mobile-facets__item--hidden', !match);
      if (match) visible++;
    });

    var noResults = submenu.querySelector('[data-facet-no-results]');
    if (noResults) noResults.hidden = visible !== 0;
  }

  // Apply the current mobile-form selections via the theme's own machinery.
  function applyMobileFilters() {
    var mobileForm = document.getElementById(MOBILE_FORM_ID);
    if (!mobileForm) return;

    var host = mobileForm.closest('facet-filters-form');
    var FacetFiltersForm = window.customElements
      ? window.customElements.get('facet-filters-form')
      : null;
    if (!host || !FacetFiltersForm || typeof host.createSearchParams !== 'function') return;

    var params = host.createSearchParams(mobileForm);
    FacetFiltersForm.renderPage(params);
  }

  // 1 & 2 — swallow input/change/keyup coming from the mobile form so the
  // theme never auto-submits; also drive the live search from the same event.
  ['input', 'change', 'keyup'].forEach(function (type) {
    document.addEventListener(
      type,
      function (event) {
        if (!event.target.closest || !event.target.closest('#' + MOBILE_FORM_ID)) return;
        event.stopPropagation();
        if (type === 'input') {
          var search = event.target.closest('[data-facet-search]');
          if (search) filterSubmenu(search);
        }
      },
      true
    );
  });

  // Apply buttons live in the main footer (.apply-btn) and in each submenu
  // footer (button.btn). Capture phase so we run before the theme's jQuery
  // close handler (which calls stopPropagation) and apply before it closes.
  document.addEventListener(
    'click',
    function (event) {
      var btn = event.target.closest(
        '.mobile-facets .apply-btn, .mobile-facets__footer button.btn'
      );
      if (!btn) return;
      applyMobileFilters();
    },
    true
  );
})();
